import { Anchor, Button, Stack, Text, TextInput, Title } from "@mantine/core";
import { IconFileText } from "@tabler/icons-react";
import * as React from "react";
import { useTranslation } from "react-i18next";
// eslint-disable-next-line @typescript-eslint/no-require-imports
const dinlabeldistribuidores = require("url:../assets/DinLabelDistribuidores.pdf");

export function NeedToRegister() {
  const { t } = useTranslation();

  return (
    <Stack gap="md">
      <div>
        <Title order={3} c="charcoal.8" mb="xs">
          {t("register.title")}
        </Title>
        <Text c="dimmed">{t("register.intro")}</Text>
      </div>
      <Anchor href={dinlabeldistribuidores} c="brand.7" fw={600} w="fit-content">
        <span style={{ display: "inline-flex", alignItems: "center", gap: 6 }}>
          <IconFileText size={16} />
          {t("portal.distributorInfo")}
        </span>
      </Anchor>
      <form id="form" action="/distributor/signup" method="post">
        <Stack gap="sm">
          <TextInput
            label={t("register.company")}
            id="companyName"
            name="companyName"
            placeholder={t("register.companyPlaceholder")}
          />
          <TextInput
            label={t("register.phone")}
            id="phoneNumber"
            name="phoneNumber"
            placeholder={t("register.phonePlaceholder")}
            description={t("register.phoneDescription")}
          />
          <TextInput
            label={t("register.street")}
            id="street"
            name="street"
            placeholder={t("register.street1Placeholder")}
          />
          <TextInput
            label={t("register.street")}
            id="street2"
            name="street2"
            placeholder={t("register.street2Placeholder")}
          />
          <TextInput
            label={t("register.number")}
            id="number"
            name="number"
            placeholder={t("register.number")}
          />
          <TextInput
            label={t("register.city")}
            id="city"
            name="city"
            placeholder={t("register.city")}
          />
          <TextInput
            label={t("register.state")}
            id="state"
            name="state"
            placeholder={t("register.state")}
          />
          <TextInput
            label={t("register.country")}
            id="country"
            name="country"
            placeholder={t("register.country")}
          />
          <TextInput
            label={t("register.zip")}
            id="zip"
            name="zip"
            placeholder={t("register.zip")}
          />
          <TextInput
            label={t("register.rfc")}
            id="businessId"
            name="businessId"
            placeholder={t("register.rfc")}
          />
          <Text c="dimmed" size="sm">
            {t("register.nextSteps")}
          </Text>
          <Button type="submit" color="brand">
            {t("register.submit")}
          </Button>
        </Stack>
      </form>
    </Stack>
  );
}
